import * as React from 'react';
import { observable } from 'mobx';
import { FormState, FieldState } from 'formstate';
import * as Validators from '../cc-validators';
import { lazyInject } from 'src/invoice/ioc';
import { InvoiceStore } from 'src/invoice/stores/invoice.store';
import { RouterStore } from 'src/core/stores/router.store';
import { BusyFormState } from 'src/util/busy-form';

export class CardInfoFormState extends BusyFormState {
    @lazyInject(InvoiceStore) private invoiceStore!: InvoiceStore;
    @lazyInject(RouterStore) private router!: RouterStore;

    @observable errorMessage: string | undefined;

    ccName = new FieldState('').validators(Validators.ccNameValidator);
    ccNumber = new FieldState('').validators(Validators.ccNumberValidator);
    ccExp = new FieldState('').validators(Validators.ccExpValidator);
    ccCsc = new FieldState('').validators(Validators.ccCscValidator);
    postalCode = new FieldState('').validators(Validators.zipPostalCodeValidator);

    form = new FormState({
        ccName: this.ccName,
        ccNumber: this.ccNumber,
        ccExp: this.ccExp,
        ccCsc: this.ccCsc,
        postalCode: this.postalCode,
        isBusy: this.isBusy
    });

    constructor() {
        super();
        const payment = this.invoiceStore.payment;
        if (!payment) {
            return;
        }

        if (!payment.card) {
            payment.card = {};
        }

        const card = payment.card;

        const existingCcExp = card.expMonth && card.expYear ? card.expMonth + card.expYear : '';
        this.ccName.reset(card.name || '');
        this.ccNumber.reset(card.number || '');
        this.ccExp.reset(existingCcExp || '');
        this.ccCsc.reset(card.cvc || '');
        this.postalCode.reset(card.billingZip || '');

        this.form.validate();
    }

    clearError = () => {
        this.errorMessage = undefined;
    };

    handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
        e && e.preventDefault();

        const payment = this.invoiceStore.payment;
        if (!payment || this.form.hasError) {
            return;
        }

        payment.card = {
            name: this.ccName.$.trim(),
            number: this.ccNumber.$.replace(/[^0-9]/g, ''),
            expMonth: this.ccExp.$.replace(/[^0-9]/g, '').substr(0, 2),
            expYear: this.ccExp.$.replace(/[^0-9]/g, '').substr(2, 2),
            cvc: this.ccCsc.$.trim(),
            billingZip: this.postalCode.$.trim(),
        };

        this.withBusy(this.invoiceStore.submitPayment(payment)).then(
            (confirmation) => {
                this.router.history.push(
                    `/invoice/${payment.invoiceNumber}/confirm-payment/${confirmation.number}`
                );
            },
            (err) => {
                this.errorMessage = err;
            }
        );
    };
}
